export const keypressIntegerControl = (event: KeyboardEvent): void => {
  const pattern = /\d/;
  if (!pattern.test(event.key) && event.code !== 'Backspace') {
    // invalid character, prevent input
    event.preventDefault();
  }
};
